__turbopack_context__.v({
  "className": "space_grotesk_84562312-module__UHZ9ha__className",
});
